/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 *
 * Forms Hooks
 *
 * Barrel export for all generic form-related UI hooks
 */

// PERFORMANCE: Explicit exports instead of export * for better tree-shaking

// Form submission
export type {
  UseFormSubmissionOptions,
  UseFormSubmissionReturn,
} from "./use-form-submission";
export { useFormSubmission } from "./use-form-submission";

// Form validation state
export type { UseFormValidationStateReturn } from "./use-form-validation-state";
export { useFormValidationState } from "./use-form-validation-state";

// Nested dialogs
export type { UseNestedDialogsReturn } from "./use-nested-dialogs";
export { useNestedDialogs } from "./use-nested-dialogs";

// Prevent double submit
export { usePreventDoubleSubmit } from "./use-prevent-double-submit";

// Scroll to first error
export { useScrollToError } from "./use-scroll-to-error";

// Unsaved changes
export { useUnsavedChanges } from "./use-unsaved-changes";

// Unsaved changes guard
export { useUnsavedChangesGuard } from "./use-unsaved-changes-guard";
